function findFocusedRoute(state) {
  var _current_index, _ref;
  var current = state;
  while ((current === null || current === void 0 ? void 0 : current.routes[(_current_index = current.index) !== null && _current_index !== void 0 ? _current_index : 0].state) != null) {
    var _current_index1;
    current = current.routes[(_current_index1 = current.index) !== null && _current_index1 !== void 0 ? _current_index1 : 0].state;
  }
  var route = current === null || current === void 0 ? void 0 : current.routes[(_ref = current === null || current === void 0 ? void 0 : current.index) !== null && _ref !== void 0 ? _ref : 0];
  return route;
}
export {
  findFocusedRoute
};
//# sourceMappingURL=findFocusedRoute.js.map
